import { Culture } from '../../types';

export const hawaiian: Culture = {
  name: 'Hawaiian',
  languageFamily: 'Austronesian',
  terms: [
    {
      word: 'Aloha',
      phonetic: 'ah-loh-hah',
      description: 'Hawaiian word meaning "hello," "goodbye," and "love."'
    },
    {
      word: 'Keiki',
      phonetic: 'keh-ee-kee',
      description: 'Hawaiian word for "child" or "children."'
    },
    {
      word: 'Mahalo',
      phonetic: 'mah-hah-loh',
      description: 'Hawaiian word for "thank you."'
    },
    {
      word: 'ʻOhana',
      phonetic: 'oh-hah-nah',
      description: 'Hawaiian word meaning "family."'
    },
    {
      word: 'Pono',
      phonetic: 'poh-noh',
      description: 'Hawaiian word meaning "righteousness" or "balance."'
    }
  ]
};